// react and mui stuff
import { useContext, useState } from "react";
import { UserContext } from "../../utils/contexts";

import { useColorScheme } from "@mui/joy/styles";
import Sheet from "@mui/joy/Sheet";
import Table from "@mui/joy/Table";
import Typography from "@mui/joy/Typography";

// custom components
import PurposeHelper from "./purposeHelper";
import UserCard from "../usercard";
import ExclusiveButtons, { RadioButton } from "../exclusivebuttons";
import { EM, GB } from "../emoji";


type props = {
  setProfile: Function
}

export default function Bank ({setProfile}: props) {
  const [currency, setCurrency] = useState<string>("gb")
  const { user } = useContext(UserContext)
  const mode = useColorScheme().mode;
  const colors = {
    light: {
      up: ["#bdcfbd", "#9bb99b"],
      down: ["#dbb3b3", "#c48383"]
    },
    dark: {
      up: ["#354B35", "#4C674C"],
      down: ["#7e3939", "#925454"]
    }
  }

  if (!user) return <div/>
  const { balances, transactions } = user;
  const currentTransactions = transactions?.[currency as "em" | "gb"] ?? []
  
  return (
    <div style={{ display: "inline-block", overflowX: "auto", width: "100%" }}>
      <div>
        <PurposeHelper helpText="View past interactions with the server currencies"/>
      </div>

      <ExclusiveButtons value={currency} setValue={setCurrency}>
        <RadioButton selected={currency} value="gb" label={<div style={{ display: "flex", alignContent: "center"}}><GB size={24}/>GB</div>}/>
        <RadioButton selected={currency} value="em" label={<div style={{ display: "flex", alignContent: "center"}}><EM size={24}/>EM</div>}/>
      </ExclusiveButtons>

      <br/>
      <div className="flexMidVert">
        <Typography level="h3" >Balance: {balances?.[currency as "gb" | "em"] ?? 0}</Typography>
        <div style={{marginLeft: "5px"}}>
          {currency === "em" ? <EM size={24}/> : <GB size={24}/>}
        </div>
      </div>

      {
        currentTransactions.length > 0 && 
        <Sheet variant="soft" sx={{ borderRadius: 'sm', overflow: "auto", maxHeight: "370px", width: "100%" }}>
          {
            currentTransactions.length > 0 && 
            <Table
              variant="soft"
              stickyHeader
              hoverRow
              noWrap={false}
              stripe="even"
              borderAxis="bothBetween"
              sx={{ tableLayout: "unset", width: "100%", overflowX: "auto" }}
              size="sm"
            >
              <thead>
                <tr>
                  <th>Value</th>
                  <th>Date</th>
                  <th>Note</th>
                  <th>User</th>
                </tr>
              </thead>
              <tbody>
                {
                  currentTransactions.map((transaction, i) => {
                    const color = mode === "dark" ? colors.dark : colors.light
                    return (
                      <tr key={transaction.key} style={{ backgroundColor: transaction.value > 0 ? color.up[i % 2] : color.down[i % 2] }}>
                        <td>{transaction.value}</td>
                        <td>{transaction.timestamp}</td>
                        <td style={{whiteSpace: "normal"}}>{transaction.description}</td>
                        <td><UserCard profile={transaction.otherUser} setProfile={setProfile} loading={false} small/></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          }
        </Sheet>
      }
      {currentTransactions.length === 0 && <><br/>No transactions to show</>}
    </div>
  )
}